import createPage from "@src/components/page"
import React from "react"
import d1Img from "@images/png/23.png"
import d2Img from "@images/png/24.png"
import * as styles from "./pageEnd.module.scss"
import { cdnUrl, pageUrl, redColor } from "@config"
import { animated } from "react-spring"
import { useEnteringTrail } from "@src/components/page/lib"
import Button from "@src/components/button"
import { useContext } from "react"
import PagesContext from "@src/context/pagesContext"

import wallpaperImg from "@images/wallpaper.jpg"
import { platformCheck, postAppMsg, postMsg } from "@src/utils/request"
import AppContext from "@src/context/appContext"

const wallpaperUrl = `${cdnUrl}${wallpaperImg}`

const totalDuration = 4000
const PageEnd = createPage(
  ({ offset, data: { myself } }) => {
    const { md } = useContext(AppContext)
    const { returnToFirst } = useContext(PagesContext)
    const animeText1Styles = useEnteringTrail(1, offset, {
      totalDuration,
      step: 0.1,
    })
    const animeText2Styles = useEnteringTrail(1, offset, {
      totalDuration,
      step: 0.3,
    })
    const animeText3Styles = useEnteringTrail(1, offset, {
      totalDuration,
      step: 0.5,
    })
    const anime2Styles = useEnteringTrail(1, offset, {
      step: 0.7,
      type: "mlt",
      totalDuration,
    })
    const anime3Styles = useEnteringTrail(1, offset, {
      step: 0.9,
      type: "mrb",
      totalDuration,
    })
    const anime4Styles = useEnteringTrail(1, offset, {
      step: 1,
      type: "mt",
      totalDuration,
    })
    return (
      <>
        <animated.div style={animeText1Styles[0]} className={styles.box1}>
          这里不过是互联网
          <br />
          荒远僻野的一角
          <br />
          闲适、工作和寄兴的所在
        </animated.div>
        <div className={styles.box2}>
          <animated.img style={anime2Styles[0]} src={d1Img} alt="d1" />
          <animated.div style={animeText2Styles[0]}>
            是在这里
            <br />
            日子悄悄流去
            <br />
            沉湎于快乐和遗忘的襟怀
          </animated.div>
        </div>
        <div className={styles.box3}>
          <animated.img style={anime3Styles[0]} src={d2Img} alt="d1" />
          <animated.div style={animeText3Styles[0]}>
            感谢过去一年中
            <br />
            你给机核带来的陪伴
            <br />
            2022
            <br />
            祝一切安好，我们与你同在
            <div className={styles.replayBtn}>
              <Button
                hollow
                onClick={() => {
                  returnToFirst()
                }}
              >
                重看
              </Button>
            </div>
          </animated.div>
        </div>
        <animated.div style={anime4Styles[0]} className={styles.buttons}>
          <Button
            hollow
            onClick={() => {
              if (myself) {
                platformCheck(
                  () => {
                    postAppMsg("navigate", {
                      link: `https://www.gcores.com/topics/372`,
                    })
                  },
                  () => {},
                  { onlyInApp: true }
                )
              } else {
                window.location.href = pageUrl
              }
            }}
          >
            {myself ? "聊聊你的机核年度报告" : "查看我的年度报告"}
          </Button>
          <Button
            onClick={() => {
              platformCheck(
                () => {
                  if (md?.is("AndroidOS")) {
                    postMsg({
                      action: "download-image",
                      data: {
                        url: wallpaperUrl,
                        fileType: "jpg",
                      },
                    })
                  } else {
                    postAppMsg("share", {
                      image: wallpaperUrl,
                    })
                  }
                },
                () => {
                  window.open(wallpaperUrl, "_blank")
                }
              )
            }}
          >
            下载壁纸
          </Button>
        </animated.div>
      </>
    )
  },
  {
    className: styles.page,
  },
  {
    totalDuration,
    showShare: true,
  }
)

export const pageEndData = {
  key: "end",
  bg: redColor,
  Page: PageEnd,
}

PageEnd.displayName = "pageEnd"
export default PageEnd
